<template>
    <section class="max-w-8xl flex items-center justify-end !moblands:w-auto md:w-full animate-pulse">
        <div class="md:max-w-xs flex items-center text-sm rounded-full !moblands:rounded-full !rounded-full:bg-transparent md:rounded-xl md:bg-white !moblands:p-0  md:p-3 shadow-modal md:pr-3 !moblands:pr-0 md:mr-3 !moblands:mr-0">
            <span class="rounded-full bg-wrh-gray-extralight !rounded-full:mr-0 h-8 w-8 md:h-10 md:w-10 md:mr-4 !moblands:mr-0"></span>
             <span class="h-5 w-20 bg-wrh-gray-extralight hidden !moblands:hidden md:inline"></span>
             <span class="w-5 h-5 bg-wrh-gray-extralight ml-4 hidden !moblands:hidden md:inline"></span>
        </div>
        </section>
</template>
